var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden
    ? _c(
        "v-app-bar",
        {
          staticClass: "mrc_mainnav_container pt-n1 pb-n1 align-center",
          class: _vm.$vuetify.breakpoint.name == "xs" ? "mobile-container" : "",
          staticStyle: { cursor: "pointer" },
          attrs: {
            "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
            app: "",
            fixed: "",
            color: "white",
            height: 56,
            flat: false,
            "clipped-right": _vm.$vuetify.breakpoint.lgAndUp,
          },
        },
        [
          _c("Progress"),
          _vm.$vuetify.breakpoint.name != "xs"
            ? _c(
                "v-toolbar-title",
                {
                  staticClass:
                    "ml-0 pr-4 py-2 align-start d-flex mrc_toolbar_title",
                  on: { dblclick: _vm.changeDemo },
                },
                [
                  !_vm.curAppInfo ||
                  !_vm.curAppInfo["user"] ||
                  !_vm.curAppInfo["user"]["logo"] ||
                  _vm.logoError
                    ? _c("svg-icon", {
                        attrs: {
                          width: "192px",
                          height: "40px",
                          iconClass: _vm.logo,
                        },
                      })
                    : _c("v-img", {
                        attrs: {
                          src: _vm.curAppInfo["user"]["logo"],
                          width: "100%",
                          "max-height": "40",
                          contain: "",
                          position: "center center",
                        },
                        on: {
                          error: function ($event) {
                            _vm.logoError = true
                          },
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticClass: "mx-4",
                              attrs: { icon: "", height: "32", width: "32" },
                              on: { click: _vm.onStretch },
                            },
                            on
                          ),
                          [
                            _c("svg-icon", {
                              attrs: {
                                size: "24",
                                fill: "currentColor",
                                iconClass: "service",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1611769230
              ),
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.drawer
                      ? _vm.$t("message_essweb_navi_tools_hideMenuTip")
                      : _vm.$t("message_essweb_navi_tools_showMenuTip")
                  )
                ),
              ]),
            ]
          ),
          _c("Breadcrumb", { attrs: { hidden: _vm.hiddenBread } }),
          _c("v-spacer"),
          _vm.showDemo
            ? _c("v-switch", {
                staticClass: "mt-5",
                attrs: {
                  height: "32",
                  label: _vm.viewkey ? "查看Label Key" : "关闭Label Key",
                },
                model: {
                  value: _vm.viewkey,
                  callback: function ($$v) {
                    _vm.viewkey = $$v
                  },
                  expression: "viewkey",
                },
              })
            : _vm._e(),
          _vm.showDemo
            ? _c("v-switch", {
                staticClass: "mt-5",
                attrs: {
                  height: "32",
                  label: _vm.demo ? "演示模式开启" : "演示模式关闭",
                },
                model: {
                  value: _vm.demo,
                  callback: function ($$v) {
                    _vm.demo = $$v
                  },
                  expression: "demo",
                },
              })
            : _vm._e(),
          _vm.allCompany.length == 1
            ? _c("span", { staticClass: "pl-5 pr-5 text-subtitle-2" })
            : _c(
                "v-menu",
                {
                  attrs: { "offset-y": "", small: "", "max-height": "300" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _vm.selectCompany
                              ? _c(
                                  "v-sheet",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "\n          text-button\n          px-2\n          mx-2\n          text-capitalize\n          d-flex\n          align-center\n          text-body-2\n        ",
                                    },
                                    on
                                  ),
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "px-1 text-truncate" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.allCompany.find(
                                                _vm.ele["uuid"] ===
                                                  _vm.selectCompany
                                              )["name"]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c("v-spacer"),
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons-round text--secondary",
                                      },
                                      [_vm._v("arrow_drop_down")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1238373503
                  ),
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.allCompany, function (item, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: index,
                          on: {
                            click: function ($event) {
                              _vm.selectCompany = item["uuid"]
                            },
                          },
                        },
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(item["name"])),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
          _vm.companyLang.length == 1
            ? _c("span", { staticClass: "pl-5 pr-5 text-subtitle-2" })
            : _c(
                "v-menu",
                {
                  attrs: { "offset-y": "", small: "", "max-height": "300" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-sheet",
                              _vm._g(
                                {
                                  staticClass:
                                    "\n          text-button\n          px-2\n          mx-2\n          text-capitalize\n          d-flex\n          align-center\n          text-body-2\n        ",
                                },
                                on
                              ),
                              [
                                _c(
                                  "div",
                                  { staticClass: "px-1 text-truncate" },
                                  [_vm._v(" " + _vm._s(_vm.showLang) + " ")]
                                ),
                                _c("v-spacer"),
                                _c(
                                  "i",
                                  {
                                    staticClass:
                                      "material-icons-round text--secondary",
                                  },
                                  [_vm._v("arrow_drop_down")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2940001168
                  ),
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.companyLang, function (item, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: index,
                          on: {
                            click: function ($event) {
                              _vm.selectLang = item["value"]
                            },
                          },
                        },
                        [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(item["text"])),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
          0
            ? _c(
                "v-badge",
                {
                  attrs: {
                    color: "error",
                    content: "8",
                    overlap: "",
                    bordered: "",
                    right: "",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2 ml-2",
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.onPop.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons-round" }, [
                        _vm._v("notifications"),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-menu",
            {
              attrs: {
                left: "",
                bottom: "",
                "offset-y": "",
                "max-height": "400",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false",
                                },
                              ],
                              staticClass: "mr-2",
                              attrs: { icon: "" },
                            },
                            on
                          ),
                          [
                            _c("i", { staticClass: "material-icons-round" }, [
                              _vm._v("notifications"),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                681068350
              ),
            },
            [
              _c(
                "v-card",
                { attrs: { dense: "", width: "200" } },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "pt-0 pb-0 d-flex align-center flex-grow-1 title",
                    },
                    [_vm._v("Notifications")]
                  ),
                  _c("v-divider"),
                  _c("v-card-text", [_c("v-list", [_c("v-list-item")], 1)], 1),
                  _c(
                    "v-card-actions",
                    { staticClass: "text-center d-flex" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "flex-grow-1",
                          attrs: { small: "", text: "", color: "primary" },
                        },
                        [_vm._v("全部已读")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false",
                                },
                              ],
                              class: _vm.fullScreen
                                ? " mr-2 ml-2"
                                : " mr-2 ml-2",
                              attrs: { icon: "", height: "32", width: "32" },
                              on: { click: _vm.openFullScreen },
                            },
                            on
                          ),
                          [
                            _c("i", { staticClass: "material-icons-round" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.fullScreen
                                    ? "fullscreen_exit"
                                    : "fullscreen"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1966320093
              ),
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.fullScreen ? "退出全屏" : "进入全屏")),
              ]),
            ]
          ),
          _c(
            "v-menu",
            {
              staticClass: "rounded-lg elevation-4",
              attrs: {
                left: "",
                bottom: "",
                "offset-y": "",
                "close-on-content-click": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      return [
                        _c(
                          "StaffAvatar",
                          _vm._g(
                            {
                              attrs: {
                                size: 36,
                                src: _vm.curAppInfo
                                  ? _vm.curAppInfo["user"]["staff_avatar"]
                                    ? _vm.curAppInfo["user"]["staff_avatar"]
                                    : null
                                  : null,
                                staff_name: _vm.curAppInfo
                                  ? _vm.curAppInfo["user"]["preferred_name"]
                                    ? _vm.curAppInfo["user"]["preferred_name"]
                                    : ""
                                  : "",
                              },
                              on: { error: _vm.onAvatarError },
                            },
                            on
                          )
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                4274861386
              ),
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass:
                    "\n        pb-3\n        align-center align-items-center\n        text-center\n        d-flex\n        flex-column\n        justify-start\n      ",
                  attrs: { width: "250" },
                },
                [
                  _c("v-sheet", {
                    staticClass: "max-width",
                    attrs: { height: "60", color: "primary lighten-2" },
                  }),
                  _c("v-file-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: { id: "avatar" },
                    on: { change: _vm.chooseUploadFile },
                  }),
                  _c("v-hover", {
                    staticClass: "mt-n9 mb-4 white--text",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var hover = ref.hover
                            return [
                              _c("StaffAvatar", {
                                attrs: {
                                  size: 72,
                                  type: "head",
                                  src: _vm.curAppInfo
                                    ? _vm.curAppInfo["user"]["staff_avatar"]
                                      ? _vm.curAppInfo["user"]["staff_avatar"]
                                      : null
                                    : null,
                                  staff_name: _vm.curAppInfo
                                    ? _vm.curAppInfo["user"]["preferred_name"]
                                      ? _vm.curAppInfo["user"]["preferred_name"]
                                      : ""
                                    : "",
                                },
                                on: {
                                  error: function (err) {
                                    return (_vm.isError = err)
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _vm.uploading
                                            ? _c(
                                                "v-sheet",
                                                {
                                                  staticClass:
                                                    "\n                d-flex\n                text-center\n                align-center\n                justify-center\n                white--text\n              ",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    background:
                                                      "rgba(0, 0, 0, 0.4)",
                                                    "font-size": "12px",
                                                  },
                                                  attrs: {
                                                    width: "100%",
                                                    height: "100%",
                                                  },
                                                },
                                                [
                                                  _c("v-progress-circular", {
                                                    attrs: {
                                                      indeterminate: "",
                                                      rotate: 10,
                                                      size: 24,
                                                      width: 2,
                                                      color: "primary",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          hover && !_vm.uploading
                                            ? _c(
                                                "v-sheet",
                                                {
                                                  staticClass:
                                                    "\n                d-flex\n                text-center\n                align-center\n                justify-center\n                white--text\n              ",
                                                  staticStyle: {
                                                    position: "absolute",
                                                    background:
                                                      "rgba(0, 0, 0, 0.4)",
                                                    "font-size": "12px",
                                                  },
                                                  attrs: {
                                                    width: "100%",
                                                    height: "100%",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ma-1",
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        ripple: false,
                                                        color: "white",
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.toUploadAvatar,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v(" edit ")]
                                                      ),
                                                    ]
                                                  ),
                                                  !_vm.isError &&
                                                  _vm.curAppInfo &&
                                                  _vm.curAppInfo["user"][
                                                    "staff_avatar"
                                                  ]
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "ma-1",
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                            ripple: false,
                                                            color: "white",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.onDeleteAvatar,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v(" delete ")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1184989912
                    ),
                  }),
                  _c(
                    "span",
                    { staticClass: "title mb-2 max-width text-truncate px-3" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.curAppInfo
                              ? _vm.$getCommonLangValue(
                                  _vm.curAppInfo.user.preferred_name
                                )
                              : _vm.$t("label_essweb_navi_notLoginLabel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "caption text--secondary mb-2 max-width text-truncate px-3",
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("label_essweb_navi_numberLabel")) +
                          ":" +
                          _vm._s(
                            _vm.curAppInfo
                              ? _vm.curAppInfo.user.staff_code
                                ? _vm.curAppInfo.user.staff_code
                                : "---"
                              : "---"
                          )
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass:
                        "caption text--secondary mb-4 max-width text-truncate px-3",
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$getCommonLangValue(
                            _vm.curAppInfo
                              ? _vm.curAppInfo.user.job_post_name
                                ? _vm.curAppInfo.user.job_post_name
                                : "---"
                              : "---"
                          )
                        )
                      ),
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text text-capitalize",
                      attrs: { rounded: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showChangeP = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("label_ChangePassword")))]
                  ),
                  _c(
                    "div",
                    { staticClass: "max-width pa-2 pt-6" },
                    [_c("v-divider", { staticClass: "max-width" })],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "text-capitalize mx-auto px-3",
                      attrs: {
                        color: "primary",
                        "retain-focus-on-click": "",
                        depressed: "",
                        small: "",
                        text: "",
                      },
                      on: { click: _vm.logOut },
                    },
                    [_vm._v(_vm._s(_vm.$t("label_essweb_navi_logOutBtnLabel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("changePassword", {
            attrs: { show: _vm.showChangeP },
            on: {
              close: function ($event) {
                _vm.showChangeP = false
              },
              onSubmit: _vm.onSubmit,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }